import { render, staticRenderFns } from "./sticky.vue?vue&type=template&id=d36d7906"
import script from "./sticky.vue?vue&type=script&lang=js"
export * from "./sticky.vue?vue&type=script&lang=js"
import style0 from "./sticky.vue?vue&type=style&index=0&id=d36d7906&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports